export const convertParamToString = function (params) {
  var paramArray = []
  for (var key in params) {
    var val = params[key]
    if (typeof val === 'object') {
      val = JSON.stringify(val)
    }
    var param = key + '=' + val
    paramArray.push(param)
  }
  paramArray.push('callback')
  if (paramArray.length > 0) {
    return paramArray.join('&')
  }
  return ''
}

export const getUrlParam = function (paramName, newHref) {
  let href = newHref || decodeURIComponent(((global.location && (global.location.search || global.location.hash)) || '')).substr(1)
  let reg = new RegExp('(^|&|\\?)' + paramName + '=([^&]*)(&|$)')
  let matchResult = href.match(reg)
  let param = matchResult ? decodeURIComponent(matchResult[2]) : ''
  return param
}

export const setMeta = function () {
  var meta = '<meta name="viewport" content="width=750,user-scalable=no" />'
  document.write(meta)
}

export const checkDeviceType = function () {
  const userAgent = window.navigator.userAgent
  const ua = userAgent.toLowerCase()
  const platform = {
    isAndroid: function () {
      return ua.indexOf('android') > -1
    },
    isRealIOS: function () {
      const NPlatform = navigator.platform
      return /iPad|iPhone|iPod/gi.test(NPlatform) || (NPlatform === 'MacIntel' && navigator.maxTouchPoints > 1 && !window.MSStream)
    },
    isWinPhone: function () {
      return !!navigator.userAgent.match(/Windows Phone/i)
    },
    isIOS: function () {
      return ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1
    },
    isPhone: function () {
      return this.isAndroid() || this.isRealIOS() || this.isWinPhone() || this.isIOS()
    }
  }
  return platform.isPhone() ? 'mobile' : 'pc'
}

/**
 * 檢查元素是否在窗口內，添加对应动画类，消失时移除动画类
 * @param {string} item .example
 * @param {string} animateClass fadeIn
 * @param {number} timeout 延迟时间，ms
 */
export const checkoutItemInWindow = function (item, animateClass, timeout = 0) {
  const itemTop = document.querySelectorAll(item)[0].offsetTop
  const winScrollTop = document.body.scrollTop
  const visualHeight = document.body.clientHeight
  if (winScrollTop + visualHeight > itemTop) {
    setTimeout(() => {
      let classVal = document.querySelectorAll(item)[0].getAttribute('class')
      classVal.concat(animateClass.replact('.', ''))
      document.querySelectorAll(item)[0].setAttribute('class', classVal)
    }, timeout)
  } else {
    let classVal = document.querySelectorAll(item)[0].getAttribute('class')
    let name = animateClass.replace('.', '')
    classVal.replace(name, '')
    document.querySelectorAll(item)[0].setAttribute('class', classVal)
  }
}
